/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const ArrowLeft = props => (
  <svg viewBox="0 0 12 10" width="1em" height="1em" {...props}>
    <path
      d="M11.501 4H3.517l2.342-2.42a.522.522 0 000-.714L5.175.149a.47.47 0 00-.684 0L.141 4.655a.526.526 0 000 .717l4.322 4.48a.466.466 0 00.684 0l.684-.716a.523.523 0 000-.716L3.49 6h8.011a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z"
      fill="#5D6164"
      fillRule="evenodd"
    />
  </svg>
);
export default extendIcon(ArrowLeft);
